import React from 'react';
import PropTypes from 'prop-types';

/**
 * A minimal top-level container that organizes multiple <ViewportPane>
 * children in a grid. Typically driven by a layout config.
 */
function ViewportGrid({ numRows, numCols, layoutType, children }) {
  return (
    <div
      data-cy="viewport-grid"
      className="relative w-full h-[92vh] min-h-[300px] bg-[#0B0F14] flex flex-wrap overflow-auto"
      style={{
        position: 'relative',
        height: '92%',
        width: '100%',
        marginTop: '4px',
      }}
    >
      {children}
    </div>
  );
}

ViewportGrid.propTypes = {
  numRows: PropTypes.number.isRequired,
  numCols: PropTypes.number.isRequired,
  layoutType: PropTypes.string,
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
};

export { ViewportGrid };
